<template>
  <div
    class="sidebar"
    :data-background-color="backgroundColor"
    :data-active-color="activeColor"
  >
    <div class="sidebar-wrapper">
      <div class="logo">
        <a class="simple-text">
          <div class="logo-img">
            <img :src="logo[logoKey]" alt="" />
          </div>
          SMARTBLAX <small>v1.997.40.33</small>
        </a>

        <set-language />

        <div class="text-white">{{ $store.state.user.name }}</div>
      </div>

      <slot> </slot>
      <ul class="nav mt-2">
        <slot name="links">
          <sidebar-link
            v-for="(link, index) in sidebarLinks"
            :key="index"
            :to="link.path"
            :name="link.name"
            :icon="link.icon"
          >
          </sidebar-link>
        </slot>
      </ul>
      <moving-arrow :move-y="arrowMovePx"> </moving-arrow>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import MovingArrow from "./MovingArrow.vue";
import SidebarLink from "./SidebarLink";
import SetLanguage from "../SetLanguage";
export default {
  props: {
    backgroundColor: {
      type: String,
      default: "black",
      validator: (value) => {
        let acceptedValues = ["white", "black", "darkblue"];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    activeColor: {
      type: String,
      default: "success",
      validator: (value) => {
        let acceptedValues = [
          "primary",
          "info",
          "success",
          "warning",
          "danger",
        ];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
    },
    autoClose: {
      type: Boolean,
      default: true,
    },
  },
  provide() {
    return {
      autoClose: this.autoClose,
      addLink: this.addLink,
      removeLink: this.removeLink,
    };
  },
  components: {
    MovingArrow,
    SidebarLink,
    SetLanguage,
  },
  computed: {
    ...mapState(["user"]),
    title: {
      get() {
        return this.user ? this.user.email : "";
      },
    },
    /**
     * Styles to animate the arrow near the current active sidebar link
     * @returns {{transform: string}}
     */
    arrowMovePx() {
      return this.linkHeight * this.activeLinkIndex;
    },
  },
  data() {
    return {
      linkHeight: 65,
      activeLinkIndex: 0,
      windowWidth: 0,
      isWindows: false,
      hasAutoHeight: false,
      links: [],

      logoKey: 0,
      logo: [
        require("@/assets/img/logo.svg"),
        require("@/assets/img/logo2.svg"),
        require("@/assets/img/logo3.svg"),
      ],
    };
  },
  methods: {
    findActiveLink() {
      this.links.forEach((link, index) => {
        if (link.isActive()) {
          this.activeLinkIndex = index;
        }
      });
    },
    addLink(link) {
      const index = this.$slots.links.indexOf(link.$vnode);
      this.links.splice(index, 0, link);
    },
    removeLink(link) {
      const index = this.links.indexOf(link);
      if (index > -1) {
        this.links.splice(index, 1);
      }
    },
  },
  mounted() {
    this.$watch("$route", this.findActiveLink, {
      immediate: true,
    });

    setInterval(() => {
      this.logoKey++;

      if (this.logoKey === 3) {
        this.logoKey = 0;
      }
    }, 5000);
  },
};
</script>
<style>
</style>
